import React from "react";

import WorkspaceOverviewIcon from "@uui/Building07";
import MeetingPolicyIcon from "@uui/ChartBreakoutSquare";
import HomeIcon from "@uui/Home02";
import { stubTrue } from "lodash/fp";

import type { SvgIconProps } from "@mui/material";

import type { FeatureAccess } from "@app/analytics/providers/FeatureAccessContext";
import {
  CalendarIcon,
  CoachingIcon,
  ForYouIcon,
  IntegrationIcon,
  RecommendationsIcon,
  ReportsIcon,
} from "@app/common/assets/icons";
import ROUTES from "@app/common/routes";

export interface ButtonConfig {
  label: string;
  url: (params: { [key: string]: string }) => string;
  activeUrls?: string[];
  icon: React.FunctionComponent<SvgIconProps>;
  beta?: boolean;
  testId?: string;
  external?: boolean;
  allowNotifications?: boolean;
  enabled: (access: FeatureAccess) => boolean;
}

export const SIDE_NAV_BUTTON_GROUPS: { key: string; items: ButtonConfig[] }[] =
  [
    {
      key: "side-nav-btn-group-1",
      items: [
        {
          testId: "side-nav-home-page",
          label: "Home",
          url: () => ROUTES.NEWSFEED,
          activeUrls: [`${ROUTES.NEWSFEED}/*`],
          icon: HomeIcon,
          allowNotifications: true,
          enabled: (featureAccess) => featureAccess.canAccessHomePage,
        },
        {
          testId: "side-nav-meeting-reports",
          label: "Reports",
          url: () => ROUTES.MEETING_REPORTS,
          activeUrls: [`${ROUTES.MEETING_REPORTS}/*`],
          icon: ReportsIcon,
          allowNotifications: false,
          enabled: stubTrue,
        },
        {
          testId: "side-nav-calendar",
          label: "Calendar",
          url: () => ROUTES.CALENDAR,
          icon: CalendarIcon,
          allowNotifications: false,
          enabled: stubTrue,
        },
      ],
    },
    {
      key: "side-nav-btn-group-2",
      items: [
        {
          testId: "side-nav-for-you",
          label: "For You",
          url: () => ROUTES.FOR_YOU,
          activeUrls: [`${ROUTES.FOR_YOU}/*`],
          icon: ForYouIcon,
          allowNotifications: false,
          enabled: stubTrue,
        },
        {
          testId: "side-nav-coaching",
          label: "Coaching",
          url: () => ROUTES.COACHING_DEFAULT_SECTION,
          activeUrls: [`${ROUTES.COACHING_ROOT}/*`],
          icon: CoachingIcon,
          allowNotifications: false,
          enabled: (featureAccess) => featureAccess.canAccessCoaching,
        },
        {
          testId: "side-nav-recommendations",
          label: "Recommendations",
          url: () => ROUTES.RECOMMENDATIONS,
          activeUrls: [`${ROUTES.RECOMMENDATIONS}/*`],
          icon: RecommendationsIcon,
          allowNotifications: true,
          enabled: stubTrue,
        },
        {
          testId: "side-nav-meeting-policy",
          label: "Meeting Policy",
          url: ({ workspaceId }) =>
            workspaceId
              ? ROUTES.workspaceMeetingPolicyById(workspaceId)
              : ROUTES.PERSONAL_MEETING_POLICY,
          icon: MeetingPolicyIcon,
          enabled: stubTrue,
        },
        {
          testId: "side-nav-workspace-overview",
          label: "Workspace Overview",
          url: ({ workspaceId }) => ROUTES.workspaceOverviewById(workspaceId),
          icon: WorkspaceOverviewIcon,
          enabled: (featureAccess) => featureAccess.canAccessWorkspaceOverview,
        },
      ],
    },
    {
      key: "side-nav-btn-group-3",
      items: [
        {
          testId: "side-nav-integrations",
          label: "Apps & Integrations",
          url: () => ROUTES.INTEGRATIONS_DEFAULT_SECTION,
          icon: IntegrationIcon,
          allowNotifications: false,
          activeUrls: [`${ROUTES.INTEGRATIONS_ROOT}/*`],
          enabled: stubTrue,
        },
      ],
    },
  ];
